import { removerAcento } from './removerAcento';

/** Utilizado na store do zustand para aplicação de filtros */
export function applyFilter<
    Filter extends object,
    State extends { filter: Partial<Filter> | undefined },
>(
    filter: Partial<Filter> | undefined,
    get: () => State,
    set: (newState: { filter: Partial<Filter> | undefined }) => void,
): void {
    const newFilter = {
        ...get().filter,
        ...filter,
    };

    const allUndefined =
        Object.keys(newFilter).length === 0 ||
        Object.keys(newFilter).every((key) => !newFilter[key]);

    if (allUndefined) {
        set({ filter: undefined });
    } else {
        set({ filter: newFilter });
    }
}

export function filterOption(
    input: string,
    option:
        | {
              value?: string | number | null;
              label?: React.ReactNode;
          }
        | undefined,
): boolean {
    if (!option?.label) {
        return false;
    }

    const opt = typeof option.label === 'string' ? option.label : '';
    const opcao = removerAcento(opt.toLowerCase());
    const valor = removerAcento(input.toLowerCase());
    return opcao.includes(valor);
}

export function filterOptionAutoComplete(input: string, option?: { value: string }): boolean {
    const opcao = removerAcento(option?.value.toLowerCase());
    const valor = removerAcento(input.toLowerCase());
    return opcao.includes(valor);
}
